<template>
  <button
    class="poi-item"
    :class="{
      active: isActive,
      loading: isLoading,
      isSavedLoading: isSavedLoading,
      parentActivity: hasChildren,
      childActivity: isChildActivity,
      notIncluded: isRecommendation,
      savedRecommendation: isSavedPoi && isRecommendation,
    }"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <div class="picture-wrapper">
      <slot>
        <!-- <div class="parent" :class="{removable: isRemoveAllowed}" @click.stop="onRemoveItem(activity)"> -->
        <div class="parent">
          <div class="container">
            <div v-if="!isLoading" class="img" :style="{backgroundImage: `${backgroundImage}`}"></div>
          </div>
        </div>
      </slot>
    </div>
    <div class="details">
      <div class="details-alligner" v-if="!hasChildren">
        <div v-if="isRecommendation" class="description" v-html="explanations" />
        <div v-else class="description" v-html="activityTime" />
        <div v-if="description && !activityTime && !isRecommendation" class="description" v-html="description" />
        <div class="name">
          <span v-if="isRecommendation && !isSavedPoi" class="suggested-add">Add: </span>
          <span v-html="formattedName" />
        </div>
      </div>
      <div v-else class="details-alligner">
        <div class="description" >{{durationTime}} Visit to:</div>
        <div class="name">
          <span v-html="formattedName" />
        </div>

      </div>

      <div class="price">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-if="withHeart"
          class="heart-icon"
          :class="{'not-included': isRecommendation}"
        >
          <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="white" />
          <path
            d="M11.9999 8.23985C11.5004 7.75235 10.8624 7.5 10.2154 7.5C9.49175 7.5 8.77927 7.81567 8.25935 8.42301C7.24596 9.60675 7.2479 11.4538 8.25904 12.6372C8.25904 12.6372 8.25904 12.6372 8.25904 12.6372L11.2687 16.1598L11.269 16.1602C11.358 16.2641 11.4682 16.3496 11.5941 16.4091L11.8076 15.9569L11.5941 16.4091C11.7201 16.4686 11.8578 16.5 11.9983 16.5C12.1388 16.5 12.2765 16.4686 12.4025 16.4091L12.189 15.9569L12.4025 16.4091C12.5284 16.3496 12.6385 16.2641 12.7275 16.1602L12.7276 16.1601L15.7402 12.6408C15.7402 12.6408 15.7402 12.6408 15.7402 12.6408C16.7533 11.4574 16.7533 9.60964 15.7402 8.42623C14.744 7.26247 13.0687 7.20032 11.9999 8.23985Z"
            fill="#FF7373"
            stroke="white"
            class="heart-path"
          />
          <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#F1F1F1" class="heart-rect" />
        </svg>
      </div>
    </div>
  </button>
</template>

<script>
import Vue from 'vue';
import {usePlaceCardLogic} from '@common/place-card-logic/place-card-logic';
import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

export default {
  name: 'TripPoiItem',
  props: {
    isActive: Boolean,
    activity: Object,
    isLoading: Boolean,
    isSavedLoading: Boolean,
    labelText: String,
    descriptionText: String,
    isRemoveAllowed: {
      type: Boolean,
      default: true,
    },
    withHeart: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {emit}) {
    const onRemoveItem = (activity) => {
      if (activity.isRecommendation) {
        return;
      }
      emit('remove-item');
    };

    return {
      ...usePlaceCardLogic(props),
      onRemoveItem,
    };
  },
};
</script>

<style scoped>
.poi-item {
  display: flex;
  padding: 8px 20px 5px;
  border-top: 1px solid #f1f1f1;
  background-size: 16px;
  background-position: 15px center;
  background-repeat: no-repeat;
  transition: 0.3s ease background-color;
  padding-right: 60px;
  position: relative;
  cursor: pointer;
  width: 100%;
  border: none;
  appearance: none;
  align-items: stretch;
  background-color: #fff;
}

.poi-item.parentActivity::after {
  content: none;
}

.poi-item::after {
  content: '';
  position: absolute;
  right: 0;
  width: 40px;
  height: 40px;
  background-size: 8px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(./icon-filter-downarrow.svg);
  transform: rotate(-90deg);
  top: 50%;
  margin-top: -20px;
}

.item.active::after {
  opacity: 0.3;
}

.parent {
  width: 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.container {
  display: block;
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  padding: 100% 0 0 0; /* 63.29% = 100 / (w / h) = 100 / (314 / 198) */
}

.container .img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
  background-size: cover;
  border-radius: var(--radiusSmall);
}

.poi-item.parentActivity .picture-wrapper {
  width: 21px;
  height: 21px;
}

.picture-wrapper {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 5px;
  flex-shrink: 0;
  display: inline-block;
}

.picture-wrapper > * {
  border-radius: 5px;
}

.picture-wrapper.flexible {
  border: 1px solid var(--recommendations-primary, #e9a43d);
}

.picture-wrapper.flexible:before {
  content: '';
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' rx='2' fill='%23E9A43D'/%3E%3Cpath d='M10.9501 11L11.3187 10.2629C11.5122 9.87583 11.8261 9.56195 12.2132 9.36842L12.9501 9L12.2131 8.63145C11.826 8.43793 11.5122 8.1241 11.3187 7.73707L10.9501 7L10.5816 7.73709C10.3881 8.12411 10.0742 8.43793 9.68723 8.63145L8.9502 9L9.6871 9.36842C10.0742 9.56195 10.3881 9.87582 10.5816 10.2629L10.9501 11Z' fill='white'/%3E%3Cpath d='M5.9502 10L6.65199 8.59633C6.84551 8.20925 7.15938 7.89538 7.54646 7.70185L8.9502 7L7.54646 6.29815C7.15938 6.10462 6.84551 5.79075 6.65199 5.40367L5.9502 4L5.24828 5.40376C5.05475 5.79079 4.74092 6.10461 4.35389 6.29813L2.9502 7L4.35389 7.70187C4.74092 7.89539 5.05475 8.20921 5.24828 8.59624L5.9502 10Z' fill='white'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  right: -3px;
  top: -3px;
  width: 14px;
  height: 14px;
  z-index: 1;
  border-radius: 2px;
}

.details {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.details-alligner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 10px;
  overflow: hidden;
  flex: 1;
  justify-content: flex-start;
}

.name {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 118.14%;
  text-align: left;
  padding-right: 30px;
  letter-spacing: -0.005em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
  white-space: nowrap;
  color: #071d3b;
}

.name .suggested-add {
  width: auto;
  min-width: fit-content;
  margin-right: 3px;
}

.description {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 118.14%;
  /* or 14px */

  letter-spacing: -0.005em;

  color: rgba(7, 29, 59, 0.41);
  text-align: left;
  padding-right: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}

.poi-item:hover .actions {
  opacity: 1;
}

.actions {
  opacity: 0;
  transition: opacity 0.2s linear;
  position: relative;
  right: 10px;
}

.price {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  flex: 0;
  margin-right: 10px;
}

.poi-item {
  padding: 4px 20px 4px 4px !important;
}
.poi-item .name {
  font-size: 13px !important;
}
.poi-item .icon {
  font-size: 22px !important;
}

.poi-item::after {
  opacity: 0.4 !important;
}

.poi-item .actions {
  position: absolute;
  right: 32px;
  top: 50%;
  margin-top: -16px;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  transition: 0.3s ease opacity, 0.3s ease background;
}
.poi-item:hover .actions {
  opacity: 0.4 !important;
}
.poi-item:hover .actions:hover {
  opacity: 0.8 !important;
  background-color: rgba(0, 0, 0, 0.1);
}
.poi-item .gear-icon {
  transform: translate(-6px, -6px) !important;
}

.loading.poi-item {
  pointer-events: none;
}

.loading.poi-item:after {
  content: none;
}

.loading .picture-wrapper,
.loading .name,
.loading .description {
  background: rgba(228, 229, 232, 0.5);
}

.loading.isSavedLoading .picture-wrapper {
  background: none;
}

.loading.isSavedLoading .picture-wrapper:before,
.loading.isSavedLoading .picture-wrapper:after {
  content: '';
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: auto;
  right: auto;
  left: 0;
  top: 0;
  background: var(--toneBw-5);
  border-radius: var(--radiusSmall);
  border: 2px solid #fff;
}

.loading.isSavedLoading .picture-wrapper:after {
  bottom: 0;
  right: 0;
  left: auto;
  top: auto;
  background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.9996 1.72012C6.27327 0.914319 5.3036 0.5 4.32308 0.5C3.31182 0.5 2.31207 0.940694 1.57894 1.79709C0.139115 3.47895 0.141685 6.11167 1.57863 7.79346C1.57863 7.79346 1.57863 7.79346 1.57863 7.79346L6.09312 13.0772L6.09346 13.0776C6.20472 13.2076 6.34193 13.3139 6.49785 13.3875C6.65391 13.4612 6.82414 13.5 6.99743 13.5C7.17071 13.5 7.34094 13.4612 7.497 13.3875C7.65292 13.3139 7.79013 13.2076 7.90139 13.0776L7.90142 13.0776L12.4204 7.79865C12.4204 7.79865 12.4204 7.79864 12.4204 7.79864C13.8599 6.11712 13.8599 3.48346 12.4204 1.80192C10.9653 0.102111 8.48755 0.074806 6.9996 1.72012Z' fill='%23C0C0C0' stroke='white'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: center;
}

.loading .picture-wrapper.flexible::before {
  content: none;
}

.loading .name,
.loading .description {
  height: 11px;
  width: 30px;
  border-radius: 5px;
}

.loading .name {
  margin-top: 5px;
}

.loading .description {
  margin-top: 5px;
  width: 115px;
}

.loading .details-alligner {
  flex: 1;
}

.loading .price {
  display: none;
}

.notIncluded {
  opacity: 0.5;
}

.notIncluded.savedRecommendation {
  opacity: 1;
}

.poi-item.parentActivity .heart-icon {
  opacity: 0;
}

.poi-item.parentActivity .details-alligner {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.poi-item.parentActivity .details-alligner .description {
  flex-shrink: 0;
  padding: 0 5px 0 0;
}

.poi-item.parentActivity .details-alligner .name {
  padding: 0;
}

.not-included {
  opacity: 0;
}

.savedRecommendation .not-included {
  opacity: 1;
}

.childActivity .picture-wrapper {
  margin-left: 20px;
}
.childActivity .picture-wrapper:after,
.childActivity .picture-wrapper:before {
  content: '';
  position: absolute;
  top: 50%;
  left: -10px;
  height: 1px;
  width: 10px;
  background-color: var(--toneBw-5);
}
.childActivity + .childActivity .picture-wrapper:after {
  top: -40px;
  left: -10px;
  height: 60px;
  width: 1px;
}
.childActivity .picture-wrapper:after {
  top: -10px;
  left: -10px;
  height: 30px;
  width: 1px;
}
</style>
